// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"efb9b77c","271":"b741a928","392":"87cd5d86","629":"b29a17f3","702":"69a95477","836":"ca837510"}[chunkId] + ".chunk.css";
};